import { render, staticRenderFns } from "./Requestname.vue?vue&type=template&id=2fd542f6"
import script from "./Requestname.vue?vue&type=script&lang=js"
export * from "./Requestname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports